import { RadioIconProps } from '@mantine/core';

import { CheckIcon } from '../../icons/CheckIcon';

export const RadioIcon = (props: RadioIconProps) => {
    return <CheckIcon {...props} />;
};
